import { defaultContext, Context } from "../models/Context";
import { EncryptDecryptService } from "./EncryptionService";

const STORAGE_KEY = "stm_1";

function storeDataToStorage(credentials: Context) {
  try {
    if (!credentials) {
      credentials = defaultContext;
    }

    //remove existing
    localStorage.removeItem(STORAGE_KEY);

    const edService = new EncryptDecryptService();

    //  // Save to local storage enc
    const A = edService.encrypt(JSON.stringify(credentials))!!.toString();

    //not enc
    // const A = JSON.stringify(credentials)!!.toString();

    //add new
    localStorage.setItem(STORAGE_KEY, A);
  } catch (error) {
    // Error saving data
    console.log(error);
  }
}

const readDataFromStorage = () => {
  try {
    let credentials = localStorage.getItem(STORAGE_KEY);

    let storage_value: any = null;
    storage_value = credentials;

    const edService = new EncryptDecryptService();

    const d = edService.decrypt(credentials);

    // let storage_value;
    if (d != null) {
      storage_value = d;
    }

    let context: Context = storage_value ? JSON.parse(storage_value) : null;

    //let cred = await getVerifiedStorageInfo(context)

    //if (credentials != null && cred != null) {
    if (context != null) {
      return context;
      //return cred
    } else {
      return defaultContext;
    }
  } catch (error) {
    console.log(error);
  }

  return defaultContext;
};

export const getStorage = () => {
  return readDataFromStorage();
};

export function setStorage(credentials: Context) {
  return storeDataToStorage(credentials);
}
